import React from "react";
import { Check, X } from "lucide-react";

export const PASSWORD_RULES = [
  ["length", "8 caractères minimum", (p) => p.length >= 8],
  ["upper", "Une majuscule", (p) => /[A-Z]/.test(p)],
  ["digit", "Un chiffre", (p) => /\d/.test(p)],
  ["special", "Un caractère spécial", (p) => /[^A-Za-z0-9]/.test(p)],
];

export const isStrongPassword = (p) => PASSWORD_RULES.every(([, , test]) => test(p));

const LEVELS = ["bg-red-500", "bg-red-500", "bg-amber-400", "bg-yellow-300", "bg-emerald-400"];
const NAMES = ["Très faible", "Faible", "Moyen", "Bon", "Fort"];

export const PasswordStrength = ({ password }) => {
  const score = PASSWORD_RULES.filter(([, , test]) => test(password)).length;
  return (
    <div className="space-y-2" data-testid="password-strength">
      <div className="flex items-center gap-2">
        <div className="flex-1 flex gap-1">
          {[1, 2, 3, 4].map((i) => (
            <div key={i} className={`h-1 flex-1 rounded-full transition-colors duration-300 ${i <= score ? LEVELS[score] : "bg-white/10"}`} />
          ))}
        </div>
        <span className="text-[11px] text-zinc-400 w-16 text-right" data-testid="password-strength-label">{NAMES[score]}</span>
      </div>
      <ul className="grid grid-cols-2 gap-x-3 gap-y-1">
        {PASSWORD_RULES.map(([key, label, test]) => {
          const ok = test(password);
          return (
            <li key={key} data-testid={`password-rule-${key}`} data-ok={ok}
                className={`flex items-center gap-1.5 text-[11px] transition-colors ${ok ? "text-emerald-300" : "text-zinc-500"}`}>
              {ok ? <Check className="h-3 w-3" /> : <X className="h-3 w-3" />} {label}
            </li>
          );
        })}
      </ul>
    </div>
  );
};
